import { createRouter, createWebHistory } from 'vue-router'
import BlankLayout from '@/layouts/BlankLayout.vue'
import frontendRoutes from './frontendRoutes'
import backofficeRoutes from './backofficeRoutes'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'MainFrontendLayout',
      component: () => import('../layouts/MainFrontendLayout.vue'),
      children: frontendRoutes,
    },
    {
      path: '/backoffice',
      name: 'MainBackofficeLayout',
      component: () => import('../layouts/MainBackofficeLayout.vue'),
      children: backofficeRoutes,
      meta: {
        admin: true,
      },
    },
    {
      path: '/login',
      name: 'LoginView',
      component: () => import('../views/LoginView.vue'),
      meta: {
        layout: BlankLayout,
        guest: true,
      },
    },
    {
      path: '/login-2fa/:code',
      name: 'TwoFaView',
      component: () => import('../views/TwoFaView.vue'),
      meta: {
        layout: BlankLayout,
        guest: true,
      },
    },

    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore()

  // Cek apakah sudah login
  const isAuthenticated = auth.authenticated

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next({ name: 'LoginView', query: { redirect: to.fullPath } })
  }

  if(isAuthenticated && to.fullPath == "/login"){
    return next({ name: 'AdmHome' })
  }

  return next()
})

export default router
